import React, { useRef, useEffect, useState } from "react";
import { FaceMesh } from "@mediapipe/face_mesh";
import * as cam from "@mediapipe/camera_utils";
import swal from 'sweetalert';
import H5AudioPlayer from "react-h5-audio-player";
import Webcam from "react-webcam";
import { RotatingLines } from "react-loader-spinner";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setfrontview, setleftview, setrightview, settopview } from "./Reducers/reducer";
import { Button, CircularProgress, Typography } from '@mui/material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { compressBase64Image, trackEvent } from "./utils/UtilityFunctions";
import i18next from "i18next";
import imgurl from "./assests/images/imgurl";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { useLocation } from 'react-router-dom';

const Aloxa = ({ selfScan, selfScanFront, selfScanTop, selfScanLeft, selfScanRight, userObj }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const blackCanvasRef = useRef(null)
  const mediaStreamRef = useRef(null)
  const [faceOrientation, setFaceOrientation] = useState(""); // State for face orientation
  const [faceAngle, setFaceAngle] = useState(''); // Current face angle
  const [isLoading, setIsLoading] = useState(false)
  const [btnMsg, setBtnMsg] = useState(''); // Message on the button
  const [startCapturing, setStartCapturing] = useState(false)
  const [step, setStep] = useState(1); // Track which step user is on
  const [imgUrls, setImgUrls] = useState([])
  const [frontStill, setFrontStill] = useState(false)
  const [leftStill, setLeftStill] = useState(false)
  const [rightStill, setRightStill] = useState(false)
  const [topStill, setTopStill] = useState(false)
  const [count, setCount] = useState(3)
  const [process, setProcess] = useState(false)
  const [captureCount, setCaptureCount] = useState(0)
  const [capturedAngles] = useState({
    front: false,
    left: false,
    right: false,
    top: false
  })
  const [noFace, setNoFace] = useState(false)
  const [captureInProgress, setCaptureInProgress] = useState(false)
  let localStream
  const [streamVid, setStreamVid] = useState(null)
  const [selfScanCapture, setSelfScanCapture] = useState(false)
  const [multiFace, setMultiFace] = useState(false)
  const [frontCaptured, setFrontCaptured] = useState(false)
  const [leftCaptured, setLeftCaptured] = useState(false)
  const [rightCaptured, setRightCaptured] = useState(false)
  const [topCaptured, setTopCaptured] = useState(false)
  const [brightness, setBrightness] = useState(null)
  const [progress, setProgress] = useState(0)
  const [gender, setGender] = useState('')
  const [camNotFound, setCamNotFound] = useState(false)
  const [isDoctor, setIsDoctor] = useState(false)
  const [isMobile, setIsMobile] = useState(false);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const locale = useSelector((state) => state.language.langData)
  let { Gender } = useSelector((state) => state.user.profile)
  let { Topview, Leftview, Rightview, Frontview } = useSelector(
    (state) => state.user.profile
  );
  // console.log("localee", locale, Gender);
  

  // useEffect(() => {
  //   // Access the camera stream using getUserMedia
  //   let reqCamPermission = () => {
  //     window.cordova.plugins.permissions.requestPermission(window.cordova.plugins.permissions.CAMERA, function (status) {
  //       if (status.hasPermission) {
  //         console.log("Camera permission granted!");
  //         // You can now access the camera
  //         startCamera()
  //       } else {
  //         console.log("Camera permission denied!");
  //       }
  //     }, () => {
  //       console.log("Permission request failed");
  //     });
  //   }

  //   if (window.cordova) {
  //     document.addEventListener('deviceready', reqCamPermission)
  //     return () => {
  //       console.log("unmount cordova");
  //       if (webcamRef.current && webcamRef.current.srcObject) {
  //         const tracks = webcamRef.current.srcObject.getTracks();
  //         tracks.forEach((track) => track.stop());
  //         webcamRef.current.srcObject = null
  //       }
  //       document.removeEventListener('deviceready', reqCamPermission)
  //     };
  //   } else {
  //     console.log("webbb", document.getElementById('webcamid'));
  //     // return () => {
  //     //   console.log("unmount web", webcamRef, mediaStreamRef);
  //     //   if(mediaStreamRef.current){
  //     //     console.log("unmount flushed");
  //     //     mediaStreamRef.current = null
  //     //   }       
  //     // }
  //     return () => {
  //       let vid = document.getElementById('reactwebcamid')
  //       console.log("unmount vid", vid);

  //       if (webcamRef.current && webcamRef.current.video) {
  //         const stream = webcamRef.current.video.srcObject;
  //         if (stream) {
  //           console.log("unmount stopped");
  //           const tracks = stream.getTracks();
  //           tracks.forEach(track => track.stop()); // Stop each track
  //         }
  //         console.log("unmount flushed");
  //         webcamRef.current.video.srcObject = null; // Flush stream
  //       }
  //     };
  //   }
  // }, []); // Re-run effect when cameraFacingMode changes

  useEffect(() => {
    if (startCapturing) {
      checkToCapture();
    } else if(selfScan && selfScanCapture){
      checkToCapture()
    }
  }, [faceAngle, step, startCapturing, captureInProgress, capturedAngles]); // Depend on faceAngle and step to trigger the next step

  useEffect(() => {
    if (!process) {
      loadFaceMesh()
    }
    if(localStorage.getItem('isDoctor')){
      setIsDoctor(true)
    } else {
      setIsDoctor(false)
    }

  }, []);

  // useEffect(() => {
  //   let stream = null;

  //   const startCamera = async () => {
  //     try {
  //       stream = await navigator.mediaDevices.getUserMedia({ video: true });
  //       setStreamVid(stream);
  //     } catch (error) {
  //       console.error("Error accessing webcam:", error);
  //     }
  //   };

  //   startCamera();

  //   return () => {
  //     if (stream) {
  //       stopCamera(stream)
  //     }
  //   };
  // }, []);

  // useEffect(() => {
  //   return () => {
  //     if (process && streamVid) {
  //       console.log("unmount streamVid");

  //       streamVid.getTracks().forEach((track) => track.stop());
  //     }
  //   };
  // }, [streamVid]);

  useEffect(() => {
    if (frontStill || leftStill || rightStill || topStill) {
      startCountdown();
    }
  }, [frontStill, leftStill, rightStill, topStill]);

  useEffect(() => {
    let gender = ''
    if(Gender == '' && !location?.state?.user_obj?.gender){
      setGender(localStorage.getItem('gender'))
    } else if (location?.state?.user_obj?.gender) {
      setGender(location?.state?.user_obj?.gender)
    } else {
      setGender(Gender)
    }
    if(selfScan && gender){
      const views = [Topview, Leftview, Rightview, Frontview];
      const filledViewsCount = views.filter(view => view.trim() !== "").length;
      const progress = gender?.toUpperCase() == "MALE" ? ((filledViewsCount / 4) * 100) : ((filledViewsCount / 2) * 100)
      setProgress(progress);
    }
  }, [Topview, Leftview, Rightview, Frontview, gender])

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, []);

  // const findBackCamera = async () => {
  //   try {
  //     // First try to get environment camera directly
  //     try {
  //       const envStream = await navigator.mediaDevices.getUserMedia({
  //         video: { facingMode: { exact: "environment" } }
  //       });
        
  //       // Get the device ID of the environment camera
  //       const track = envStream.getVideoTracks()[0];
  //       const deviceId = track.getSettings().deviceId;
        
  //       envStream.getTracks().forEach(track => track.stop());
  //       setSelectedCamera(deviceId);
  //       return deviceId;
  //     } catch (envError) {
  //       console.log("Exact environment camera not found, trying alternatives");
  //     }

  //     // Fallback: enumerate devices and test capabilities
  //     const devices = await navigator.mediaDevices.enumerateDevices();
  //     const videoDevices = devices.filter(device => device.kind === 'videoinput');
      
  //     for (const device of videoDevices) {
  //       try {
  //         const stream = await navigator.mediaDevices.getUserMedia({
  //           video: { deviceId: device.deviceId }
  //         });
          
  //         const track = stream.getVideoTracks()[0];
  //         const capabilities = track.getCapabilities();
  //         const settings = track.getSettings();
          
  //         // Multiple criteria for back camera detection
  //         const hasHighResolution = capabilities.width?.max > 1280;
  //         const hasZoom = capabilities.zoom !== undefined;
  //         const hasTorch = capabilities.torch !== undefined;
  //         const highFrameRate = capabilities.frameRate?.max >= 30;
          
  //         stream.getTracks().forEach(track => track.stop());
          
  //         // Score-based selection
  //         let score = 0;
  //         if (hasHighResolution) score += 3;
  //         if (hasZoom) score += 2;
  //         if (hasTorch) score += 2;
  //         if (highFrameRate) score += 1;
          
  //         if (score >= 4) { // Likely back camera
  //           setSelectedCamera(device.deviceId);
  //           return device.deviceId;
  //         }
  //       } catch (error) {
  //         console.log(`Cannot test device ${device.deviceId}`);
  //       }
  //     }
      
  //     // Final fallback: prefer "environment" facing mode
  //     const envStream = await navigator.mediaDevices.getUserMedia({
  //       video: { facingMode: "environment" }
  //     });
      
  //     const track = envStream.getVideoTracks()[0];
  //     const deviceId = track.getSettings().deviceId;
  //     envStream.getTracks().forEach(track => track.stop());
      
  //     setSelectedCamera(deviceId);
  //     return deviceId;
      
  //   } catch (error) {
  //     console.error('Error finding back camera:', error);
  //     setSelectedCamera(null);
  //     return null;
  //   }
  // };

  // const findBackCamera = async () => {
  //   try {
  //     // Step 1: Request generic permission first (important for Android labels)
  //     try {
  //       const tempStream = await navigator.mediaDevices.getUserMedia({ video: true });
  //       tempStream.getTracks().forEach(track => track.stop());
  //     } catch (permErr) {
  //       console.log("Permission error:", permErr);
  //       setSelectedCamera(null);
  //       return null;
  //     }

  //     const isAndroid = /Android/i.test(navigator.userAgent);

  //     // Step 2: Try exact environment camera (works best on iOS)
  //     try {
  //       const envStream = await navigator.mediaDevices.getUserMedia({
  //         video: { facingMode: { exact: "environment" } }
  //       });
        
  //       const track = envStream.getVideoTracks()[0];
  //       const deviceId = track.getSettings().deviceId;
        
  //       envStream.getTracks().forEach(track => track.stop());
  //       setSelectedCamera(deviceId);
  //       return deviceId;
  //     } catch (envError) {
  //       console.log("Exact environment camera not found, trying alternatives");
  //     }

  //     // Step 3: Enumerate devices
  //     const devices = await navigator.mediaDevices.enumerateDevices();
  //     const videoDevices = devices.filter(device => device.kind === 'videoinput');

  //     // Step 3a: Label-based fallback for Android
  //     if (isAndroid) {
  //       const backCam = videoDevices.find(d =>
  //         d.label.toLowerCase().includes("back") ||
  //         d.label.toLowerCase().includes("rear")
  //       );
  //       if (backCam) {
  //         setSelectedCamera(backCam.deviceId);
  //         return backCam.deviceId;
  //       }
  //     }

  //     // Step 3b: Capability scoring system
  //     for (const device of videoDevices) {
  //       try {
  //         const stream = await navigator.mediaDevices.getUserMedia({
  //           video: { deviceId: device.deviceId }
  //         });
          
  //         const track = stream.getVideoTracks()[0];
  //         const capabilities = track.getCapabilities();
          
  //         stream.getTracks().forEach(track => track.stop());
          
  //         const hasHighResolution = capabilities.width?.max > 1280;
  //         const hasZoom = capabilities.zoom !== undefined;
  //         const hasTorch = capabilities.torch !== undefined;
  //         const highFrameRate = capabilities.frameRate?.max >= 30;
          
  //         let score = 0;
  //         if (hasHighResolution) score += 3;
  //         if (hasZoom) score += 2;
  //         if (hasTorch) score += 2;
  //         if (highFrameRate) score += 1;
          
  //         // Lower threshold for Android
  //         if (score >= (isAndroid ? 2 : 4)) {
  //           setSelectedCamera(device.deviceId);
  //           return device.deviceId;
  //         }
  //       } catch (error) {
  //         console.log(`Cannot test device ${device.deviceId}`);
  //       }
  //     }

  //     // Step 4: Final fallback with generic environment facing mode
  //     try {
  //       const envStream = await navigator.mediaDevices.getUserMedia({
  //         video: { facingMode: "environment" }
  //       });
        
  //       const track = envStream.getVideoTracks()[0];
  //       const deviceId = track.getSettings().deviceId;
  //       envStream.getTracks().forEach(track => track.stop());
        
  //       setSelectedCamera(deviceId);
  //       return deviceId;
  //     } catch (fallbackErr) {
  //       console.error("Fallback environment mode failed:", fallbackErr);
  //     }

  //     // If all fails
  //     setSelectedCamera(null);
  //     return null;

  //   } catch (error) {
  //     console.error('Error finding back camera:', error);
  //     setSelectedCamera(null);
  //     return null;
  //   }
  // };

  // Utility: stop all active streams
const stopAllStreams = () => {
  if (window.currentStreams) {
    window.currentStreams.forEach(stream => {
      stream.getTracks().forEach(track => track.stop());
    });
    window.currentStreams = [];
  }
};

// Utility: retry wrapper for getUserMedia (handles NotReadableError)
const getStreamWithRetry = async (constraints, retries = 2, delay = 500) => {
  try {
    stopAllStreams();
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    window.currentStreams = [stream];
    return stream;
  } catch (err) {
    if (err.name === "NotReadableError" && retries > 0) {
      console.log("Retrying camera access after NotReadableError...");
      await new Promise(res => setTimeout(res, delay));
      return getStreamWithRetry(constraints, retries - 1, delay);
    }
    throw err;
  }
};

const findBackCamera = async () => {
  try {
    // Step 1: Request generic permission first (important for Android labels)
    try {
      const tempStream = await getStreamWithRetry({ video: true });
      tempStream.getTracks().forEach(track => track.stop());
    } catch (permErr) {
      console.log("Camera permission error:", permErr.name);

      if (permErr.name === "NotReadableError") {
        alert("Camera is already in use by another app. Please close it and try again.");
      }

      setSelectedCamera(null);
      return null;
    }

    const isAndroid = /Android/i.test(navigator.userAgent);

    // Step 2: Try exact environment camera (best for iOS)
    try {
      const envStream = await getStreamWithRetry({
        video: { facingMode: { exact: "environment" } }
      });

      const track = envStream.getVideoTracks()[0];
      const deviceId = track.getSettings().deviceId;

      envStream.getTracks().forEach(track => track.stop());
      setSelectedCamera(deviceId);
      return deviceId;
    } catch (envError) {
      console.log("Exact environment camera not found, trying alternatives");
    }

    // Step 3: Enumerate devices
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter(device => device.kind === 'videoinput');

    // Step 3a: Label-based fallback for Android
    if (isAndroid) {
      const backCam = videoDevices.find(d =>
        d.label.toLowerCase().includes("back") ||
        d.label.toLowerCase().includes("rear")
      );
      if (backCam) {
        setSelectedCamera(backCam.deviceId);
        return backCam.deviceId;
      }
    }

    // Step 3b: Capability scoring system
    for (const device of videoDevices) {
      try {
        const stream = await getStreamWithRetry({
          video: { deviceId: device.deviceId }
        });

        const track = stream.getVideoTracks()[0];
        const capabilities = track.getCapabilities();

        stream.getTracks().forEach(track => track.stop());

        const hasHighResolution = capabilities.width?.max > 1280;
        const hasZoom = capabilities.zoom !== undefined;
        const hasTorch = capabilities.torch !== undefined;
        const highFrameRate = capabilities.frameRate?.max >= 30;

        let score = 0;
        if (hasHighResolution) score += 3;
        if (hasZoom) score += 2;
        if (hasTorch) score += 2;
        if (highFrameRate) score += 1;

        // Lower threshold for Android
        if (score >= (isAndroid ? 2 : 4)) {
          setSelectedCamera(device.deviceId);
          return device.deviceId;
        }
      } catch (error) {
        console.log(`Cannot test device ${device.deviceId}`, error.name);
      }
    }

    // Step 4: Final fallback with generic environment facing mode
    try {
      const envStream = await getStreamWithRetry({
        video: { facingMode: "environment" }
      });

      const track = envStream.getVideoTracks()[0];
      const deviceId = track.getSettings().deviceId;
      envStream.getTracks().forEach(track => track.stop());

      setSelectedCamera(deviceId);
      return deviceId;
    } catch (fallbackErr) {
      console.error("Fallback environment mode failed:", fallbackErr.name);
    }

    // If all fails
    setSelectedCamera(null);
    return null;

  } catch (error) {
    console.error('Error finding back camera:', error.name);
    setSelectedCamera(null);
    return null;
  }
};


  // Function to switch camera
  const switchCamera = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(device => device.kind === 'videoinput');
      
      if (videoDevices.length > 1) {
        const currentIndex = videoDevices.findIndex(device => device.deviceId === selectedCamera);
        const nextIndex = (currentIndex + 1) % videoDevices.length;
        const nextCamera = videoDevices[nextIndex];
        
        console.log('Switching to camera:', nextCamera.label);
        setSelectedCamera(nextCamera.deviceId);
      }
    } catch (error) {
      console.error('Error switching camera:', error);
    }
  };

  // Function to handle camera errors and fallback
  const handleCameraError = (error) => {
    console.error('Camera error:', error);
    
    // If there's an error with the selected camera, try to fallback to default
    if (selectedCamera) {
      console.log('Falling back to default camera');
      setSelectedCamera(null);
    }
  };

  // Effect to find back camera when component mounts
  useEffect(() => {
    if (!window.cordova && isMobile) {
      // Add a small delay to ensure the component is fully mounted
      const timer = setTimeout(() => {
        findBackCamera();
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [isMobile]);

  // Handle camera permission changes
  useEffect(() => {
    const handleDeviceChange = () => {
      if (!window.cordova && isMobile) {
        findBackCamera();
      }
    };

    navigator.mediaDevices?.addEventListener('devicechange', handleDeviceChange);
    
    return () => {
      navigator.mediaDevices?.removeEventListener('devicechange', handleDeviceChange);
    };
  }, [isMobile]);

  // const stopCamera = async (stream) => {
  //   try {
  //     const devices = await navigator.mediaDevices.enumerateDevices();
  //     const videoInputs = devices.filter((device) => device.kind === "videoinput");

  //     for (const device of videoInputs) {
  //       const stream = await navigator.mediaDevices.getUserMedia({ video: { deviceId: device.deviceId } });
  //       stream.getTracks().forEach((track) => {
  //         console.log(`Stopping track: ${track.label}`);
  //         track.stop();
  //       });
  //       stream.getVideoTracks().forEach((vTrack) => {
  //         vTrack.enabled = false
  //         console.log(`Stopping vtrack: ${vTrack}`);

  //       })
  //     }
  //     console.log("Camera turned off successfully.", stream, 'streamVid', streamVid);
  //   } catch (error) {
  //     console.error("Error turning off camera:", error);
  //   }
  // };

  // const startCamera = async () => {
  //   try {
  //     localStream = await navigator.mediaDevices.getUserMedia({
  //       video: true
  //     });
  //     if (webcamRef.current) {
  //       webcamRef.current.srcObject = localStream;
  //       webcamRef.current.play();
  //     }
  //     // setCameraStarted(true)
  //   } catch (error) {
  //     console.error('Error accessing the camera:', error);
  //   }
  // };

  // const loadFaceMesh = () => {
  //   try {
  //     let params = window.cordova ? webcamRef.current : webcamRef.current.video
  //     let camera = null;
  //     setIsLoading(true)
  //     const faceMesh = new FaceMesh({
  //       locateFile: (file) => {
  //         return `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`;
  //       },
  //     });

  //     // console.log("facemeshh", faceMesh);
  //     faceMesh.setOptions({
  //       maxNumFaces: 10,
  //       minDetectionConfidence: 0.5,
  //       minTrackingConfidence: 0.5,
  //     });

  //     faceMesh.onResults(onResults);

  //     if (
  //       typeof webcamRef.current !== "undefined" &&
  //       webcamRef.current !== null
  //     ) {
  //       // console.log("webcamRef.current.video", webcamRef.current);
  //       let params = window.cordova ? webcamRef.current : webcamRef.current.video
  //       camera = new cam.Camera(params, {
  //         onFrame: async () => {
  //           try {
  //             await faceMesh.send({ image: params });
  //           } catch (err) {
  //             console.log('err', err)
  //           }
  //         },
  //       });
  //       camera.start();
  //     }
  //   } catch (err) {
  //     console.log("err>>>>>>", err)
  //   }
  // }

  // const loadFaceMesh = async () => {
  //   try {
  //     setIsLoading(true);

  //     // Check for camera permissions
  //     const hasPermission = await navigator.mediaDevices.getUserMedia({ video: true })
  //       .then((stream) => {
  //         // Immediately stop the stream once we confirm permission
  //         stream.getTracks().forEach((track) => track.stop());
  //         return true;
  //       })
  //       .catch((err) => {
  //         console.log("Camera permission error:", err.name);
  //         if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
  //           // alert("Camera permission denied. Please enable camera access to proceed.");
  //           setCamNotFound(true)
  //         } else {
  //           // alert("Unable to access the camera. Please check your device settings.");
  //           setCamNotFound(true)
  //         }
  //         return false;
  //       });

  //     if (!hasPermission) {
  //       setIsLoading(false);
  //       return;
  //     }

  //     // Load FaceMesh model
  //     const faceMesh = new FaceMesh({
  //       locateFile: (file) => {
  //         return `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`;
  //       },
  //     });

  //     faceMesh.setOptions({
  //       maxNumFaces: 10,
  //       minDetectionConfidence: 0.5,
  //       minTrackingConfidence: 0.5,
  //     });

  //     faceMesh.onResults(onResults);

  //     if (
  //       typeof webcamRef.current !== "undefined" &&
  //       webcamRef.current !== null
  //     ) {
  //       let params = window.cordova ? webcamRef.current : webcamRef.current.video;
  //       const camera = new cam.Camera(params, {
  //         onFrame: async () => {
  //           try {
  //             await faceMesh.send({ image: params });
  //           } catch (err) {
  //             console.log('err', err);
  //           }
  //         },
  //       });
  //       camera.start();
  //     }
  //   } catch (err) {
  //     console.log("err>>>>>>", err);
  //     setIsLoading(false);
  //   }
  // };

  const loadFaceMesh = async () => {
  try {
    setIsLoading(true);

    // Step 1: Check for camera permissions (with retry + cleanup)
    const hasPermission = await getStreamWithRetry({ video: true })
      .then((stream) => {
        // Immediately stop the stream once we confirm permission
        stream.getTracks().forEach((track) => track.stop());
        return true;
      })
      .catch((err) => {
        console.log("Camera permission error:", err.name);

        if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
          setCamNotFound(true);
        } else if (err.name === "NotReadableError") {
          alert("Camera is already in use by another app. Please close it and try again.");
          setCamNotFound(true);
        } else {
          setCamNotFound(true);
        }

        return false;
      });

    if (!hasPermission) {
      setIsLoading(false);
      return;
    }

    // Step 2: Load FaceMesh model
    const faceMesh = new FaceMesh({
      locateFile: (file) => {
        return `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`;
      },
    });

    faceMesh.setOptions({
      maxNumFaces: 10,
      minDetectionConfidence: 0.5,
      minTrackingConfidence: 0.5,
    });

    faceMesh.onResults(onResults);

    // Step 3: Initialize camera feed
    if (typeof webcamRef.current !== "undefined" && webcamRef.current !== null) {
      let params = window.cordova ? webcamRef.current : webcamRef.current.video;
      const camera = new cam.Camera(params, {
        onFrame: async () => {
          try {
            await faceMesh.send({ image: params });
          } catch (err) {
            console.log("FaceMesh error:", err);
          }
        },
      });
      camera.start();
    }
  } catch (err) {
    console.log("loadFaceMesh error:", err);
    setIsLoading(false);
  }
};



  // const onResults = (results) => {
  //   if (!process) {
  //     let widthParam = window.cordova ? webcamRef.current.videoWidth : webcamRef.current.video.videoWidth
  //     let heightParam = window.cordova ? webcamRef.current.videoHeight : webcamRef.current.video.videoHeight
  //     const videoWidth = widthParam;
  //     const videoHeight = heightParam;

  //     // Set canvas width and height
  //     canvasRef.current.width = videoWidth;
  //     canvasRef.current.height = videoHeight;

  //     const canvasElement = canvasRef.current;
  //     const canvasCtx = canvasElement.getContext("2d");
  //     canvasCtx.save();
  //     canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
  //     canvasCtx.drawImage(results.image, 0, 0, videoWidth, videoHeight);

  //     if (results.multiFaceLandmarks && results.multiFaceLandmarks.length == 1) {
  //       for (const landmarks of results.multiFaceLandmarks) {
  //         setMultiFace(false)
  //         setNoFace(false)
  //         setIsLoading(false)
  //         const noseTip = landmarks[1];  // Nose tip
  //         const leftEyeOuter = landmarks[33]; // Left eye outer
  //         const rightEyeOuter = landmarks[263]; // Right eye outer
  //         const chin = landmarks[152]; // Chin bottom

  //         if ((!selfScan && step === 1) || (selfScan && selfScanFront)) {
  //           applyTaperedCurvedRectangleMask(canvasCtx, landmarks, videoWidth, videoHeight);
  //         } else {
  //           applyTaperedCurvedRectangleMaskSide(canvasCtx, landmarks, videoWidth, videoHeight)
  //         }

  //         // Face Orientation Logic
  //         const eyeMidPointX = (leftEyeOuter.x + rightEyeOuter.x) / 2;
  //         const noseOffsetX = noseTip.x - eyeMidPointX;
  //         const eyeMidPointY = (leftEyeOuter.y + rightEyeOuter.y) / 2;
  //         const chinOffsetY = chin.y - eyeMidPointY;
  //         const yawAngleThreshold = 0.10;
  //         const topViewThreshold = 0.20;
  //         let orientationMessage = "";
  //         let face = "";
  //         if (noseOffsetX > yawAngleThreshold) {
  //           orientationMessage = i18next.t("RIGHT PROFILE");
  //           face = "LEFT";
  //         } else if (noseOffsetX < -yawAngleThreshold) {
  //           orientationMessage = i18next.t("LEFT PROFILE");
  //           face = "RIGHT";
  //         } else if (chinOffsetY < topViewThreshold) {
  //           orientationMessage = i18next.t("FACING DOWN");
  //           face = "TOP";
  //         } else {
  //           orientationMessage = i18next.t("FACING FRONT");
  //           face = "FRONT";
  //         }
  //         setFaceOrientation(orientationMessage);
  //         setFaceAngle(face);
  //       }
  //     } else if (results.multiFaceLandmarks && (results.multiFaceLandmarks.length != 1 && results.multiFaceLandmarks.length != 0)) {
  //       for (const landmarks of results.multiFaceLandmarks) {
  //         if ((!selfScan && step === 1) || (selfScan && selfScanFront)) {
  //           applyTaperedCurvedRectangleMask(canvasCtx, landmarks, videoWidth, videoHeight);
  //         } else {
  //           applyTaperedCurvedRectangleMaskSide(canvasCtx, landmarks, videoWidth, videoHeight)
  //         }
  //       }
  //       setMultiFace(true)
  //     } else if (results?.multiFaceLandmarks?.length == 0) {
  //       setMultiFace(false)
  //       let times = 1
  //       setFaceAngle('');
  //       if (!process && times === 1) {
  //         setNoFace(true)
  //       }
  //       if (!process) {
  //         setNoFace(true)
  //       }
  //     }
  //     canvasCtx.restore();
  //   }
  // };

  const onResults = (results) => {
    if (!process) {
      let widthParam = window.cordova ? webcamRef.current.videoWidth : webcamRef.current.video.videoWidth
      let heightParam = window.cordova ? webcamRef.current.videoHeight : webcamRef.current.video.videoHeight
      const videoWidth = widthParam;
      const videoHeight = heightParam;
      const blackVideoWidth = widthParam;
      const blackVideoHeight = heightParam;

      // Set canvas width and height
      canvasRef.current.width = videoWidth;
      canvasRef.current.height = videoHeight;

      blackCanvasRef.current.width = blackVideoWidth;
      blackCanvasRef.current.height = blackVideoHeight;

      const canvasElement = canvasRef.current;
      const canvasCtx = canvasElement.getContext("2d");

      const blackCanvasElement = blackCanvasRef.current;
      const blackCanvasCtx = blackCanvasElement.getContext("2d");

      canvasCtx.save();
      canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
      canvasCtx.drawImage(results.image, 0, 0, videoWidth, videoHeight);

      const frame = canvasCtx.getImageData(0, 0, videoWidth, videoHeight);
      const pixels = frame.data;
      let total = 0;
      for (let i = 0; i < pixels.length; i += 4) {
        const r = pixels[i];
        const g = pixels[i + 1];
        const b = pixels[i + 2];
        total += 0.299 * r + 0.587 * g + 0.114 * b;
      }

      const avgBrightness = total / (videoWidth * videoHeight);
      setBrightness(Math.round(avgBrightness)); // Make sure you define this state

      if (results.multiFaceLandmarks && results.multiFaceLandmarks.length == 1) {
        for (const landmarks of results.multiFaceLandmarks) {
          setMultiFace(false)
          setNoFace(false)
          setIsLoading(false)
          const noseTip = landmarks[1];  // Nose tip
          const leftEyeOuter = landmarks[33]; // Left eye outer
          const rightEyeOuter = landmarks[263]; // Right eye outer
          const chin = landmarks[152]; // Chin bottom

          if ((!selfScan && step === 1) || (selfScan && selfScanFront)) {
            applyTaperedCurvedRectangleMask(canvasCtx, landmarks, videoWidth, videoHeight);
          } else {
            applyTaperedCurvedRectangleMaskSide(canvasCtx, landmarks, videoWidth, videoHeight)
          }

          // Face Orientation Logic
          const eyeMidPointX = (leftEyeOuter.x + rightEyeOuter.x) / 2;
          const noseOffsetX = noseTip.x - eyeMidPointX;
          const eyeMidPointY = (leftEyeOuter.y + rightEyeOuter.y) / 2;
          const chinOffsetY = chin.y - eyeMidPointY;
          const yawAngleThreshold = 0.05;
          const topViewThreshold = 0.20;
          let orientationMessage = "";
          let face = "";
          if (noseOffsetX > yawAngleThreshold) {
            orientationMessage = i18next.t("RIGHT PROFILE");
            face = "LEFT";
          } else if (noseOffsetX < -yawAngleThreshold) {
            orientationMessage = i18next.t("LEFT PROFILE");
            face = "RIGHT";
          } else if (chinOffsetY < topViewThreshold) {
            orientationMessage = i18next.t("FACING DOWN");
            face = "TOP";
          } else {
            orientationMessage = i18next.t("FACING FRONT");
            face = "FRONT";
          }
          setFaceOrientation(orientationMessage);
          setFaceAngle(face);
        }
      } else if (results.multiFaceLandmarks && (results.multiFaceLandmarks.length != 1 && results.multiFaceLandmarks.length != 0)) {
        for (const landmarks of results.multiFaceLandmarks) {
          if ((!selfScan && step === 1) || (selfScan && selfScanFront)) {
            applyTaperedCurvedRectangleMask(canvasCtx, landmarks, videoWidth, videoHeight);
          } else {
            applyTaperedCurvedRectangleMaskSide(canvasCtx, landmarks, videoWidth, videoHeight)
          }
        }
        setMultiFace(true)
      } else if (results?.multiFaceLandmarks?.length == 0) {
        setMultiFace(false)
        let times = 1
        setFaceAngle('');
        if (!process && times === 1) {
          setNoFace(true)
        }
        if (!process) {
          setNoFace(true)
        }
      }

      // Apply sharp vignette effect
      const centerX = videoWidth / 2;
      const centerY = videoHeight / 2;
      const radius = Math.min(videoWidth, videoHeight) * 0.25; // Adjust radius as needed

      const vignetteGradient = blackCanvasCtx.createRadialGradient(
        centerX, centerY, radius,       // Inner circle (clear)
        centerX, centerY, radius * 2.2  // Outer fade to dark
      );

      // Define the gradient stops for a sharp effect
      vignetteGradient.addColorStop(0.0, "rgba(0, 0, 0, 0)");
      vignetteGradient.addColorStop(0.35, "rgba(0, 0, 0, 0)");   // Bigger clear center
      vignetteGradient.addColorStop(0.36, "rgba(0, 0, 0, 0.3)"); // Sharp transition starts
      vignetteGradient.addColorStop(1.0, "rgba(0, 0, 0, 0.3)");

      // Draw the vignette
      blackCanvasCtx.fillStyle = vignetteGradient;
      blackCanvasCtx.fillRect(0, 0, videoWidth, videoHeight);

      // const centerX = videoWidth / 2;
      // const centerY = videoHeight / 2;
      // const innerRadius = Math.min(videoWidth, videoHeight) * 0.25;
      // const outerRadius = innerRadius * 2.5;

      // const horizontalSquish = 0.7; // Makes inner circle narrower (vertical oval)

      // blackCanvasCtx.save();

      // // Apply horizontal scale to get vertical oval effect
      // blackCanvasCtx.translate(centerX, centerY);
      // blackCanvasCtx.scale((videoWidth / videoHeight) * horizontalSquish, 1);
      // blackCanvasCtx.translate(-centerX, -centerY);

      // // Create the radial gradient
      // const vignetteGradient = blackCanvasCtx.createRadialGradient(
      //   centerX, centerY, innerRadius,
      //   centerX, centerY, outerRadius
      // );

      // vignetteGradient.addColorStop(0.0, "rgba(0, 0, 0, 0)");
      // vignetteGradient.addColorStop(0.35, "rgba(0, 0, 0, 0)");
      // vignetteGradient.addColorStop(0.36, "rgba(0, 0, 0, 0.3)");
      // vignetteGradient.addColorStop(1.0, "rgba(0, 0, 0, 0.3)");

      // // Fill a large enough area to fully cover canvas even after scaling
      // blackCanvasCtx.fillStyle = vignetteGradient;
      // blackCanvasCtx.fillRect(
      //   centerX - outerRadius * 2,
      //   centerY - outerRadius * 2,
      //   outerRadius * 4,
      //   outerRadius * 4
      // );

      // blackCanvasCtx.restore();
      canvasCtx.restore();
    }
  };

  const applyTaperedCurvedRectangleMask = (ctx, landmarks, videoWidth, videoHeight) => {
    ctx.fillStyle = "white"; // Set mask color

    // 1. Get Key Face Landmarks
    const leftBrowEnd = landmarks[105];
    const rightBrowEnd = landmarks[334];
    const foreheadMid = landmarks[151];
    const chin = landmarks[152];
    const noseTip = landmarks[1];

    // 2. Calculate Face Orientation (Left/Right)
    const eyeMidX = (leftBrowEnd.x + rightBrowEnd.x) / 2;
    const noseOffsetX = noseTip.x - eyeMidX; // How far nose deviates from center

    let faceTurnFactor = Math.abs(noseOffsetX) * 3; // Stronger effect
    faceTurnFactor = Math.min(faceTurnFactor, 1.5); // Limit max distortion

    // 3. Calculate Mask Position
    let centerX = ((leftBrowEnd.x + rightBrowEnd.x) / 2) * videoWidth;
    let centerY = ((foreheadMid.y + chin.y) / 2) * videoHeight;

    let topWidth = Math.abs(rightBrowEnd.x - leftBrowEnd.x) * videoWidth * (1.5 + 5 * faceTurnFactor);  // **Even more expansion**
    let bottomWidth = topWidth * (0.8 + 1 * faceTurnFactor); // Slight expansion at bottom
    let height = Math.abs(chin.y - foreheadMid.y) * videoHeight * 1;

    const borderRadius = topWidth * 0.3; // Slightly more rounded for smoothness

    // Adjust centerX slightly when turning left or right
    centerX += noseOffsetX * videoWidth * 0.4; // Stronger shift

    // 4. Draw the Tapered Curved Mask
    ctx.beginPath();

    // Top-left curve
    ctx.moveTo(centerX - topWidth / 2 + borderRadius, centerY - height / 2);
    ctx.lineTo(centerX + topWidth / 2 - borderRadius, centerY - height / 2);
    ctx.quadraticCurveTo(centerX + topWidth / 2, centerY - height / 2, centerX + topWidth / 2, centerY - height / 2 + borderRadius);

    // Right edge (stronger narrowing)
    ctx.lineTo(centerX + bottomWidth / 2, centerY + height / 2 - borderRadius);
    ctx.quadraticCurveTo(centerX + bottomWidth / 2, centerY + height / 2, centerX + bottomWidth / 2 - borderRadius, centerY + height / 2);

    // Bottom edge
    ctx.lineTo(centerX - bottomWidth / 2 + borderRadius, centerY + height / 2);
    ctx.quadraticCurveTo(centerX - bottomWidth / 2, centerY + height / 2, centerX - bottomWidth / 2, centerY + height / 2 - borderRadius);

    // Left edge (stronger narrowing)
    ctx.lineTo(centerX - topWidth / 2, centerY - height / 2 + borderRadius);
    ctx.quadraticCurveTo(centerX - topWidth / 2, centerY - height / 2, centerX - topWidth / 2 + borderRadius, centerY - height / 2);

    ctx.closePath();
    ctx.fill();
  };

  const applyTaperedCurvedRectangleMaskSide = (ctx, landmarks, videoWidth, videoHeight) => {
    ctx.fillStyle = "white"; // Set mask color

    // Key landmarks
    const leftEar = landmarks[234];
    const rightEar = landmarks[454];
    const leftBrowEnd = landmarks[105];
    const rightBrowEnd = landmarks[334];
    const foreheadMid = landmarks[151];
    const chin = landmarks[152];
    const noseTip = landmarks[1];

    let centerX, topWidth, bottomWidth, height, centerY;

    // Check if eye/brow landmarks are available
    const eyeLandmarksExist = leftBrowEnd?.x && rightBrowEnd?.x;

    if (eyeLandmarksExist) {
      // Face orientation
      const eyeMidX = (leftBrowEnd.x + rightBrowEnd.x) / 2;
      const noseOffsetX = noseTip.x - eyeMidX;
      let faceTurnFactor = Math.abs(noseOffsetX) * 3;
      faceTurnFactor = Math.min(faceTurnFactor, 1.5);

      const leftX = Math.min(leftEar?.x ?? leftBrowEnd.x, leftBrowEnd.x);
      const rightX = Math.max(rightEar?.x ?? rightBrowEnd.x, rightBrowEnd.x);
      centerX = ((leftX + rightX) / 2) * videoWidth;

      topWidth = Math.abs(rightX - leftX) * videoWidth * (1.2 + 3.0 * faceTurnFactor);
      bottomWidth = topWidth * (0.85 + 0.8 * faceTurnFactor);
      height = Math.abs(chin.y - foreheadMid.y) * videoHeight * 0.9;
      centerY = ((foreheadMid.y + chin.y) / 2) * videoHeight;

      centerX += noseOffsetX * videoWidth * 0.4;
    } else {
      // Fallback: cover full face using ears and chin
      const leftX = leftEar?.x ?? 0.25;
      const rightX = rightEar?.x ?? 0.75;
      const topY = foreheadMid?.y ?? 0.3;
      const bottomY = chin?.y ?? 0.85;

      centerX = ((leftX + rightX) / 2) * videoWidth;
      centerY = ((topY + bottomY) / 2) * videoHeight;
      topWidth = Math.abs(rightX - leftX) * videoWidth * 1.6;
      bottomWidth = topWidth * 1.1;
      height = Math.abs(bottomY - topY) * videoHeight * 1.2;
    }

    const borderRadius = topWidth * 0.25;

    // Draw the mask
    ctx.beginPath();

    // Top edge
    ctx.moveTo(centerX - topWidth / 2 + borderRadius, centerY - height / 2);
    ctx.lineTo(centerX + topWidth / 2 - borderRadius, centerY - height / 2);
    ctx.quadraticCurveTo(
      centerX + topWidth / 2,
      centerY - height / 2,
      centerX + topWidth / 2,
      centerY - height / 2 + borderRadius
    );

    // Right edge
    ctx.lineTo(centerX + bottomWidth / 2, centerY + height / 2 - borderRadius);
    ctx.quadraticCurveTo(
      centerX + bottomWidth / 2,
      centerY + height / 2,
      centerX + bottomWidth / 2 - borderRadius,
      centerY + height / 2
    );

    // Bottom edge
    ctx.lineTo(centerX - bottomWidth / 2 + borderRadius, centerY + height / 2);
    ctx.quadraticCurveTo(
      centerX - bottomWidth / 2,
      centerY + height / 2,
      centerX - bottomWidth / 2,
      centerY + height / 2 - borderRadius
    );

    // Left edge
    ctx.lineTo(centerX - topWidth / 2, centerY - height / 2 + borderRadius);
    ctx.quadraticCurveTo(
      centerX - topWidth / 2,
      centerY - height / 2,
      centerX - topWidth / 2 + borderRadius,
      centerY - height / 2
    );

    ctx.closePath();
    ctx.fill();
  };

  const startCountdown = () => {
    let counter = 6;
    setCount(counter); // Initialize countdown to 3

    const intervalId = setInterval(() => {
      if (counter > 1) {
        counter--;
        setCount(counter); // Update countdown
      } else {
        clearInterval(intervalId); // Stop the countdown when it reaches 1
      }
    }, 1000); // Update every second
  };

  const messageList = 
  locale == 'en' ?
    {
      front: i18next.t('Photo Captured, Now Face Left to Capture your Right Profile'),
      left: i18next.t('Photo Captured, Now Face Right to Capture your Left Profile'),
      right: i18next.t('Photo Captured, Now Tilt your Head Down to Capture the Top of you head'),
      top: i18next.t('Process Completed'),
    } : 
  locale == 'es' ?
    {
      front: i18next.t('Foto Capturada, Ahora mire hacia la izquierda para capturar su perfil derecho'),
      left: i18next.t('Foto capturada, ahora mira hacia la derecha para capturar tu perfil izquierdo'),
      right: i18next.t('Foto capturada, ahora incline la cabeza hacia abajo para capturar la parte superior de la cabeza'),
      top: i18next.t('Proceso completado'),
    } :
  locale == 'fr' ?
    {
      front: i18next.t('Photo capturée, maintenant tourner à gauche pour capturer votre profil droit'),
      left: i18next.t('Photo capturée, tournez maintenant à droite pour capturer votre profil gauche'),
      right: i18next.t('Photo capturée, inclinez maintenant votre tête vers le bas pour capturer le sommet de votre tête'),
      top: i18next.t('Processus complété'),
    } : ''

  const checkToCapture = () => {
    if(!selfScan){
      if (step === 1 && faceAngle === 'FRONT' && gender?.toUpperCase() === "MALE") {
        setCaptureInProgress(true)
        setFrontStill(true)
        setBtnMsg(i18next.t('FACING FRONT'));
      } else if (capturedAngles.front && step === 2 && faceAngle === 'LEFT' && gender?.toUpperCase() === "MALE") {
        setCaptureInProgress(true)
        setLeftStill(true)
        setBtnMsg(i18next.t('FACING LEFT'));
      } else if (capturedAngles.left && step === 3 && faceAngle === 'RIGHT' && gender?.toUpperCase() === "MALE") {
        setCaptureInProgress(true)
        setRightStill(true)
        setBtnMsg(i18next.t('FACING RIGHT'));
      } else if (capturedAngles.right && step === 4 && noFace && gender?.toUpperCase() === "MALE") {
        setCaptureInProgress(true)
        setTopStill(true)
        setBtnMsg(i18next.t('FACING DOWN'));
      } else if (step === 1 && faceAngle === 'FRONT' && gender?.toUpperCase() === "FEMALE") {
        setCaptureInProgress(true)
        setFrontStill(true)
        setBtnMsg(i18next.t('FACING FRONT'));
      } else if (capturedAngles.front && step === 2 && noFace && gender?.toUpperCase() === "FEMALE") {
        setCaptureInProgress(true)
        setTopStill(true)
        setBtnMsg(i18next.t('FACING DOWN'));
      }
    } else {
      if(faceAngle === 'FRONT'){
        setFrontStill(true)
      } else if(faceAngle === "LEFT"){
        setLeftStill(true)
      } else if(faceAngle === "RIGHT"){
        setRightStill(true)
      } else if(noFace){
        setTopStill(true)
      }
    }
  };

  const captureImg = async (step) => {
    setCaptureInProgress(true)
    let imageSrc
    if (!imageSrc) {
      // imageSrc = canvasRef.current.getScreenshot();
      try {
        imageSrc = canvasRef.current.toDataURL('png');
      } catch (err) {
        console.log("captureimg err", err);
        swal({
          title: i18next.t('Encountered an error while capturing image, retake or try self scan instead?')
        })
      }
      // console.log("imageSrc", imageSrc);

      if (step === 1 && gender?.toUpperCase() === "MALE") {
        setFrontStill(false)
        dispatch(setfrontview(await compressBase64Image(imageSrc.split(',')[1])))
        setProgress(35)
      } else if (step === 2 && gender?.toUpperCase() === "MALE") {
        setLeftStill(false)
        dispatch(setrightview(await compressBase64Image(imageSrc.split(',')[1])))
        setProgress(50)
      } else if (step === 3 && gender?.toUpperCase() === "MALE") {
        setRightStill(false)
        dispatch(setleftview(await compressBase64Image(imageSrc.split(',')[1])))
        setProgress(85)
      } else if (step === 4 && gender?.toUpperCase() === "MALE") {
        setTopStill(false)
        dispatch(settopview(await compressBase64Image(imageSrc.split(',')[1])))
        setProgress(100)
      } else if (step === 1 && gender?.toUpperCase() === "FEMALE") {
        setFrontStill(false)
        dispatch(setfrontview(await compressBase64Image(imageSrc.split(',')[1])))
        setProgress(50)
      } else if (step === 2 && gender?.toUpperCase() === "FEMALE") {
        setTopStill(false)
        dispatch(settopview(await compressBase64Image(imageSrc.split(',')[1])))
        setProgress(100)
      }
      setImgUrls([...imgUrls, imageSrc])
    }
    // console.log("Captured Image:", imageSrc.split(',')[1]);
    if (step === 4 && gender?.toUpperCase() === "MALE") {
      setProcess(true)
    } 
    // else if(step === 2 && gender.toUpperCase() === "FEMALE") {
    //   setProcess(true)
    // }

    let tutorialSrc = step === 1 ? 'https://res.cloudinary.com/dgeiynco8/image/upload/v1743413587/gifs/pyoyithmtsvaflhhsbgf.gif' :
      step === 2 ? 'https://res.cloudinary.com/dgeiynco8/image/upload/v1743413674/gifs/v0qarlguq4ytwuoch5bf.gif' :
        step === 3 ? 'https://res.cloudinary.com/dgeiynco8/image/upload/v1743413701/gifs/eobf406970yqbpia76ym.gif' : ''

    if (imageSrc && step != 4) {
      // swal({
      //   title: step === 1 ? messageList.front : step === 2 ? messageList.left : step === 3 ? messageList.right : step === 4 ? messageList.top : '',
      //   buttons: {
      //     confirm: {
      //       text: 'Proceed'
      //     }
      //   },
      //   content: {
      //     element: 'img',
      //     attributes: {
      //       src: tutorialSrc
      //     }
      //   }
      // }).then(() => {
      //   if (step === 1) {
      //     capturedAngles.front = true
      //     setFrontCaptured(false)
      //   } else if (step === 2) {
      //     capturedAngles.left = true
      //     setRightCaptured(false)
      //   } else if (step === 3) {
      //     capturedAngles.right = true
      //     setLeftCaptured(false)
      //   } else if (step === 4) {
      //     capturedAngles.top = true
      //     setTopCaptured(false)
      //     processFurther()
      //   }

      //   if (step !== 4) {
      //     setCaptureInProgress(false)
      //   } else {
      //     setCaptureInProgress(true)
      //   }
      // })
      if (step === 1 && gender.toUpperCase() == 'MALE') {
        capturedAngles.front = true
        setFrontCaptured(false)
      } else if (step === 2 && gender.toUpperCase() == 'MALE') {
        capturedAngles.left = true
        setRightCaptured(false)
      } else if (step === 3 && gender.toUpperCase() == 'MALE') {
        capturedAngles.right = true
        setLeftCaptured(false)
      } else if (step === 4 && gender.toUpperCase() == 'MALE') {
        capturedAngles.top = true
        setTopCaptured(false)
        processFurther()
      } else if (step === 1 && gender.toUpperCase() == 'FEMALE') {
        capturedAngles.front = true
        setFrontCaptured(false)
      } else if (step === 2 && gender.toUpperCase() == 'FEMALE') {
        capturedAngles.top = true
        setTopCaptured(false)
        processFurther()
      }
      if (step !== 4) {
        setCaptureInProgress(false)
      } else {
        setCaptureInProgress(true)
      }
    }
  };

  const selfCapture = () => {
    if(selfScanCapture){
      window.location.reload()
    } else {
      if (selfScan && selfScanFront && !noFace) {
        setSelfScanCapture(true)
      } else if (selfScan && selfScanTop && !noFace) {
        setSelfScanCapture(true)
      } else if (selfScan && selfScanLeft && !noFace) {
        setSelfScanCapture(true)
      } else if (selfScan && selfScanRight && !noFace) {
        setSelfScanCapture(true)
      }
    }
  }

  const captureForWeb = async () => {
    try {
      let imgSrc = canvasRef.current.toDataURL('png');
      if (imgSrc) {
        if (selfScanFront) {
          dispatch(setfrontview(await compressBase64Image(imgSrc.split(',')[1])))
        } else if (selfScanTop) {
          dispatch(settopview(await compressBase64Image(imgSrc.split(',')[1])))
        } else if (selfScanLeft) {
          dispatch(setleftview(await compressBase64Image(imgSrc.split(',')[1])))
        } else if (selfScanRight) {
          dispatch(setrightview(await compressBase64Image(imgSrc.split(',')[1])))
        }
        navigate('/taketest', { state: {goTo: "taketest"}})
      }
    } catch (err) {
      console.log('err', err)
      swal({
        title: i18next.t('Error capturing photo, please reload')
      })
    }
  }

  const captureForAssisted = async () => {
    try {
      let imgSrc = canvasRef.current.toDataURL('png');
      if (imgSrc) {
        if (selfScanFront) {
          dispatch(setfrontview(await compressBase64Image(imgSrc.split(',')[1])))
        } else if (selfScanTop) {
          dispatch(settopview(await compressBase64Image(imgSrc.split(',')[1])))
        } else if (selfScanLeft) {
          dispatch(setleftview(await compressBase64Image(imgSrc.split(',')[1])))
        } else if (selfScanRight) {
          dispatch(setrightview(await compressBase64Image(imgSrc.split(',')[1])))
        }
        if((selfScanRight && userObj?.gender?.toUpperCase() === 'MALE') || (selfScanTop && userObj?.gender?.toUpperCase() === 'FEMALE')) {
          navigate('/preview', {state: {from: 'selfscan', user_obj: userObj}})
        } else {
          navigate('/taketest', { state: {goTo: "taketest", user_obj: userObj}})
        }
      }
    } catch (err) {
      console.log('err', err)
      swal({
        title: i18next.t('Error capturing photo, please reload')
      })
    }
  }

  const handleCapturing = async () => {
    try {
      await trackEvent('smart_scan_initiated', 'success', '', localStorage.getItem('phno'))  
      console.log('captureCount', captureCount)
      if (captureCount === 0) {
        // if (faceAngle === 'FRONT' || startCapturing) {
          setStartCapturing(true)
          setCaptureCount(captureCount + 1)
        // }
      } else if (captureCount === 1) {
        await trackEvent('smart_scan_stopped', 'success', '', localStorage.getItem('phno'))
        location.reload()
      } else {
        swal({
          title: i18next.t('Please hold your camera straight at face level to detect front face')
        })
      }
    } catch (err) {
      console.log("err", err); 
      await trackEvent('smart_scan_initiated', 'fail', err, localStorage.getItem('phno'))  
    }
  }

  const onVoiceEnd = () => {
    if (multiFace) {
      setMultiFace(false)
    }
    if (selfScan) {
      // setSelfScanCapture(false)
      if ((!multiFace && !noFace && selfScanCapture) || (!multiFace && selfScanTop && selfScanCapture)) {
        captureForWeb()
      }
    } else {
      if (frontStill && step === 1 && gender.toUpperCase() === "MALE") {
        if (!multiFace && !noFace) {
          captureImg(step)
          setStep(2);
          setFrontCaptured(true)
        }
      } else if (leftStill && step === 2 && gender.toUpperCase() === "MALE") {
        if (!multiFace && !noFace) {
          captureImg(step);
          setStep(3);
          setRightCaptured(true)
        }
      } else if (rightStill && step === 3 && gender.toUpperCase() === "MALE") {
        if (!multiFace && !noFace) {
          captureImg(step)
          setStep(4);
          setLeftCaptured(true)
        }
      } else if (topStill && step === 4 && gender.toUpperCase() === "MALE") {
        if (!multiFace) {
          captureImg(step)
          setStep(5);
          setTopCaptured(true)
        }
      } else if (frontStill && step === 1 && gender.toUpperCase() === "FEMALE") {
        if (!multiFace && !noFace) {
          captureImg(step)
          setStep(2);
          setFrontCaptured(true)
        }
      } else if (topStill && step === 2 && gender.toUpperCase() === "FEMALE") {
        if (!multiFace) {
          captureImg(step)
          setStep(5);
          setTopCaptured(true)
        }
      } else if (step === 5) {
        processFurther()
      }
    }
  }

  const processFurther = async () => {
    navigate('/preview', { state: { from: 'aloxa' } })
  }

  const handleUserMedia = (stream) => {
    mediaStreamRef.current = stream
  }

  const handleRetake = () => {
    // navigate('/taketest',{state: {from: 'aloxa'}})
    location.reload()
  }

  return (
    <div className="rootCamera">
      {
        !selfScan && !camNotFound && 
          <div className="camNote mt-5px mb-5px">
            {
              gender.toUpperCase() == "MALE" ?
                <p>{i18next.t("Click ‘Scan your hairline’ and follow the instructions. No tapping or manual clicking needed. The system will automatically mask your face.")}</p> 
                  :
                <p>{i18next.t("Click ‘Scan your hairline’ and follow the instructions. No tapping or manual clicking needed. The system will automatically mask your face.")}</p>
            }
          </div>
      }
      {
        camNotFound ? 
          <div className="noCamDiv">
            <div className="nocammain">
              <img src={imgurl.nocam_icon} className="nocamimg"/>
              <p>No Camera Found</p>
            </div>
            <div className="allowcamsteps">
              <div className="allowcamstephead">
                <CameraAltIcon/>
                <h4 className="enableAccesstext">{i18next.t("How to enable Camera Access")}</h4>
              </div>
              <div className="allowcamsteppoints">
                <span className="stepnum">1.</span><span className="steptxt">{i18next.t("Tap/click the 🔒 lock icon near the address bar.")}</span><br/>
                <span className="stepnum">2.</span><span className="steptxt">{i18next.t("Set “Camera” to “Allow” in the permissions list.")}</span><br/>
                <span className="stepnum">3.</span><span className="steptxt">{`If not visible, go to Browser Settings > Site Settings > Camera, find your site, and Allow.`}</span><br/>
                <span className="stepnum">4.</span><span className="steptxt">{i18next.t("Refresh the page and try again.")}</span><br/>
              </div>
            </div>
          </div> 
            :
          <div>
            {
              !selfScan ?
                <div className="cameraPreview">
                 {/* <Typography variant="body2" className="subtitle mt-15px mb-0">
                            {i18next.t("Click on Start Capturing button below")}
                  </Typography> */}
                  {
                    isLoading ?
                      <RotatingLines
                        visible={true}
                        height="96"
                        width="96"
                        color="blue"
                        strokeWidth="5"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        className={"customLoader"}
                      /> : noFace && !captureInProgress ?
                        // <div>
                        //   <h1 className="captureComplete">Profile not detected </h1>
                        //   <button className="manualTstBtn" onClick={() => location.reload()}>Manual Test</button> 
                        // </div> 
                        ''
                        :
                        <div>
                          {
                            !process &&
                            <div style={{ top: "500px" }}>
                              {/* <p className="notemsg">
                                Hold the camera steady at face level and closer to your face throughout the process.
                              </p> */}
                              {
                                !startCapturing ?
                                  <p style={{ fontSize: "20px" }} className="startCapture">
                                    {/* Click on Start Capturing */}
      
                                  </p>
                                  :
                                  // <p style={{ fontSize: "20px" }} className="detectCapture">
                                  //   {i18next.t("Face")} {" "}
                                  //   {
                                  //     step === 1 && gender.toUpperCase() == "MALE" ?
                                  //       'FRONT' : 
                                  //     step === 2 && gender.toUpperCase() == "MALE" ? 
                                  //       'LEFT' : 
                                  //     step === 3 && gender.toUpperCase() == "MALE" ? 
                                  //       'RIGHT' : 
                                  //     step === 4 && gender.toUpperCase() == "MALE" ? 
                                  //       'DOWN' :
                                  //     step === 1 && gender.toUpperCase() == "FEMALE" ?
                                  //       'FRONT' : 
                                  //     step === 2 && gender.toUpperCase() == "FEMALE" ? 
                                  //       'DOWN' :  
                                  //     ''
                                  //   }
                                  // </p>
                                  ''
                              }
                            </div>
                          }
                        </div>
                  }
                  <div className="canvavideodiv smartscan">
                    {/* {
                      process ? 
                        ''
                        : */}
                    <div className="cameraContainer">
                      <div className="videoDiv">
                        {
                          window.cordova ?
                            <video
                              id="webcamid"
                              ref={webcamRef}
                              autoPlay
                              playsInline
                            ></video> :
                            <Webcam
                              id="reactwebcamid"
                              ref={webcamRef}
                              onUserMedia={handleUserMedia}
                              onUserMediaError={handleCameraError}
                              screenshotQuality={1}
                              screenshotFormat="image/png"
                              mirrored={false}
                              videoConstraints={{
                                deviceId: selectedCamera ? { exact: selectedCamera } : undefined,
                                facingMode: selectedCamera ? undefined : "environment",
                                // width: { ideal: 1280 },
                                // height: { ideal: 720 }
                              }}
                            />
                        }
                      </div>
                      <canvas
                        ref={canvasRef}
                        className="output_canvas position-relative"
                      ></canvas>
                      <canvas
                        ref={blackCanvasRef}
                        className="output_canvas blackcanvas"
                      ></canvas>
                      {
                        !isLoading && <CircularProgress variant="determinate" thickness={1.0} value={progress} className={gender.toUpperCase() === "MALE" ? "circular_imgUpload smartscan" : "circular_imgUpload smartscan female"}/>
                      }
                      {/* {brightness !== null && (
                        <div className="brightnessdiv">
                          <p>Brightness: {brightness}</p>
                          {brightness < 135 && <p style={{ color: 'red' }}>Too Dark</p>}
                          {brightness > 180 && <p style={{ color: 'orange' }}>Too Bright</p>}
                        </div>
                      )} */}
                    </div>
                    {
                      !isLoading && 
                        <div className="vidTutorial cursor-pointer">
                          <Button className="cursor-pointer" onClick={() => navigate('/tutorial')}>
                            {/* <OndemandVideoIcon className="cursor-pointer"/> */}
                            <PlayCircleIcon className="cursor-pointer" />
                            {i18next.t("Need Help?")}
                            {/* <img src={imgurl.helpIcon}/> */}
                          </Button>
                          {isMobile && (
                            <Button 
                              className="cursor-pointer ml-10px" 
                              onClick={switchCamera}
                              style={{ marginLeft: '10px' }}
                            >
                              <CameraAltIcon className="cursor-pointer" />
                              {i18next.t("Switch Camera")}
                            </Button>
                          )}
                        </div>
                    } 
                    <div className="scanFaceDirection">
                      {
                        !isLoading &&
                        <div className="volumeupdiv">
                          <VolumeUpIcon />
                          <p>{i18next.t("Turn up the volume")}</p>
                        </div>
                      }
                      <div>
                        {
                          gender.toUpperCase() == "MALE" &&
                            <div className={step === 2 ? "arrowInstant left" : step === 3 ? "arrowInstant right" : ''}>
                              {
                                step === 2 ?
                                  <img className="arrowInst white left" src="https://res.cloudinary.com/dgeiynco8/image/upload/v1751866499/fast-backward_7fac_1_nrjoao.gif" /> :
                                  step === 3 ?
                                    <img className="arrowInst white right" src="https://res.cloudinary.com/dgeiynco8/image/upload/v1751866489/fast-forward_b926_1_miyacq.gif" /> : ''
                                    // step === 4 ?
                                    //   <img className="arrowInst" src="https://res.cloudinary.com/dgeiynco8/image/upload/v1745231689/gifs/fwz7o31ytf2ir2q7ndg0.gif" /> :
                                    //   ''
                              }
                            </div>
                        }
                      </div>
                    </div>
                    {/* } */}
                  </div>
                 
                  {
                    noFace && !captureInProgress ?
                      // <div>
                      //   <p style={{ fontSize: "20px"}} className="detectCapture">{i18next.t("Profile not detected ")}</p>
                      // </div> 
                      <div className="multiFaceDiv">
                        <p>{i18next.t("Profile not detected")}</p>
                      </div>
                      : ''
                    // <p style={{ fontSize: "20px"}} className="detectCapture">
                    //   {i18next.t("DETECTED")}: {faceOrientation}
                    // </p> 
                  }
                  {/* <div>
                     {brightness !== null && (
                        <div className="brightnessdiv">
                          {brightness < 135 && <p className="brightnesstxt">Light Conditions Too Dark</p>}
                          {brightness > 180 && <p className="brightnesstxt">Light Conditions Too Bright</p>}
                        </div>
                      )}
      
                  </div> */}
                  <div className="btnDiv">
                    {
                      !process &&
                      <button className={
                        captureCount === 0 && !noFace && !multiFace ? 
                          'photoCommoncapture commonButton' 
                            : 
                        (captureCount === 0 && (noFace || multiFace)) || 135 < brightness > 180 ? 
                          'photoCommoncapture disabledBtn commonButton' 
                            : 
                          'startCapturing commonButton'
                        } 
                        onClick={() => handleCapturing()} 
                        disabled={(captureCount === 0 && (noFace || multiFace)) || 135 < brightness > 180 ? true : false}>{captureCount === 0 ? i18next.t('Scan your hairline') : i18next.t('Stop Scanning')}</button>
                    }
                    {/* <button className={noFace ? 'retakeBtn disabledBtn' : "retakeBtn"} disabled={noFace ? true : false} onClick={() => handleRetake()}>Retake</button> */}
                  </div>
                  {
                    multiFace &&
                    <div className="multiFaceDiv">
                      <p>{i18next.t("It seems there is more than one person in the frame. Please readjust your position.")}</p>
                    </div>
                  }
                  {
                    noFace && !topStill &&
                    <div className="multiFaceDiv">
                      <p>{i18next.t("Profile not detected ")}</p>
                    </div>
                  }
                  <H5AudioPlayer
                    autoPlay
                    src={
                      captureCount == 0 && !isLoading && !multiFace && locale == 'en' && gender.toUpperCase() == "MALE" ?
                       'https://res.cloudinary.com/dgeiynco8/video/upload/v1752474201/Male_-_Click_on_start_capturing_and_face_towards_camera_and_stay_still_moxkxc.mp3' : 
                      captureCount == 0 && !isLoading && !multiFace && locale == 'es' && gender.toUpperCase() == "MALE" ?
                       'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552181/spanish-1_vwodbc.mp3' : 
                      captureCount == 0 && !isLoading && !multiFace && locale == 'fr' && gender.toUpperCase() == "MALE" ?
                       'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552965/french-1_xkso34.mp3' : 
                      captureCount == 0 && !isLoading && !multiFace && locale == 'en' && gender.toUpperCase() == "FEMALE" ?
                       'https://res.cloudinary.com/dgeiynco8/video/upload/v1752474256/Female_-_Click_on_start_capturing_and_face_towards_camera_and_stay_still_w9pkgm.mp3' : 
                      captureCount == 0 && !isLoading && !multiFace && locale == 'es' && gender.toUpperCase() == "FEMALE" ?
                       'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552685/spanish-1_f7y15d.mp3' : 
                      captureCount == 0 && !isLoading && !multiFace && locale == 'fr' && gender.toUpperCase() == "FEMALE" ?
                       'https://res.cloudinary.com/dgeiynco8/video/upload/v1752553184/french-1_p7qynv.mp3' : 
                      (
                      locale == 'en' && gender.toUpperCase() === "MALE" ?
                        (!multiFace && !noFace && frontStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645015/audio/human_audio/english/male/smart/n43pflatl16fk6ddpu2n.mp3' :
                          !multiFace && !noFace && leftStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645144/audio/human_audio/english/male/smart/rlabtwb8tqupcwdrw5ta.mp3' :
                            !multiFace && !noFace && rightStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645278/audio/human_audio/english/male/smart/bcbgr6fefetlyucpy4sm.mp3' :
                              !multiFace && noFace && topStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645374/audio/human_audio/english/male/smart/qyvp3abgusvz0xfi1vjo.mp3' :
                                !frontStill && !frontCaptured && step === 2 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645427/audio/human_audio/english/male/smart/xejjch82str4ty3sa9k4.mp3' :
                                  !leftStill && !rightCaptured && step === 3 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645479/audio/human_audio/english/male/smart/wbkmcs29qmkcir10vjem.mp3' :
                                    !rightStill && !leftCaptured && step === 4 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645528/audio/human_audio/english/male/smart/e0docsrhoscb1ft4iegt.mp3' :
                                      process ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645563/audio/human_audio/english/male/smart/es5coi0fo03vmyphv2l0.mp3' :
                                        multiFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645603/audio/human_audio/english/male/smart/zxfcoc2ws8wkft5rvjia.mp3' : 
                                          !multiFace && noFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645654/audio/human_audio/english/male/smart/ndpfbqnmgd0oalgo3uiq.mp3' : '' )
                        : 
                      locale == 'es' && gender.toUpperCase() === "MALE" ?
                        (!multiFace && !noFace && frontStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552247/spanish-2_uytlox.mp3' :
                          !multiFace && !noFace && leftStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552249/spanish-3_p8mxsb.mp3' :
                            !multiFace && !noFace && rightStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552250/spanish-4_y2di2a.mp3' :
                              !multiFace && noFace && topStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552248/spanish-5_fbx3rv.mp3' :
                                !frontStill && !frontCaptured && step === 2 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552252/spanish-6_tbly0m.mp3' :
                                  !leftStill && !rightCaptured && step === 3 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552253/spanish-7_nthjle.mp3' :
                                    !rightStill && !leftCaptured && step === 4 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552255/spanish-8_c4nnis.mp3' :
                                      process ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552250/spanish-9_bxt6bf.mp3' :
                                        multiFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552251/spanish-10_lk7ajz.mp3' : 
                                          !multiFace && noFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552253/spanish-11_cynubb.mp3' : '' )
                        : 
                      locale == 'fr' && gender.toUpperCase() === "MALE" ? 
                        (!multiFace && !noFace && frontStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552972/french-2_ynbquu.mp3' :
                          !multiFace && !noFace && leftStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552967/french-3_x0jv7v.mp3' :
                            !multiFace && !noFace && rightStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552968/french-4_drnvcz.mp3' :
                              !multiFace && noFace && topStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709145/audio/human_audio/french/male/smart/gtfvjwbtqnv8v6f2rosu.mp3' :
                                !frontStill && !frontCaptured && step === 2 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552970/french-6_dxl6kf.mp3' :
                                  !leftStill && !rightCaptured && step === 3 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552980/french-7_ehalkm.mp3' :
                                    !rightStill && !leftCaptured && step === 4 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552982/french-8_unfmhr.mp3' :
                                      process ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552974/french-9_v9oene.mp3' :
                                        multiFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552976/french-10_ylpb63.mp3' : 
                                          !multiFace && noFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552978/french-11_igcwmd.mp3' : '' )
                        :
                      locale == 'en' && gender.toUpperCase() === "FEMALE" ?
                        (!multiFace && !noFace && frontStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701875/audio/human_audio/english/female/smart/kzdx7d5emuxx1ivv0ycj.mp3' :
                          !multiFace && noFace && topStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701957/audio/human_audio/english/female/smart/etmvwb4xpbvweasowtw6.mp3' :
                            !frontStill && !frontCaptured && step === 2 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702013/audio/human_audio/english/female/smart/vatuf7s3w7y10m5tx15j.mp3' :
                              process ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702046/audio/human_audio/english/female/smart/fj4qph4qzrruzpqnnhdw.mp3' :
                                multiFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702079/audio/human_audio/english/female/smart/fcplm8e4lgji1zzaayj4.mp3' : 
                                  !multiFace && noFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702110/audio/human_audio/english/female/smart/wua79jbwmb9ffuidwkc8.mp3' : '' )
                        : 
                      locale == 'es' && gender.toUpperCase() === "FEMALE" ?
                        (!multiFace && !noFace && frontStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552688/spanish-2_kgor2j.mp3' :
                          !multiFace && noFace && topStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552685/spanish-5_slqfps.mp3' :
                            !frontStill && !frontCaptured && step === 2  ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552690/spanish-8_rcrx80.mp3' :
                              process ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552686/spanish-9_tppg1y.mp3' :
                                multiFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552689/spanish-10_ugrfct.mp3' : 
                                  !multiFace && noFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752552687/spanish-11_lbkget.mp3' : '' )
                        : 
                      locale == 'fr' && gender.toUpperCase() === "FEMALE" ? 
                        (!multiFace && !noFace && frontStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752553193/french-2_xdr8zc.mp3' :
                          !multiFace && noFace && topStill ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709711/audio/human_audio/french/female/smart/h7evh8sc2aeozz9kvici.mp3' :
                            !frontStill && !frontCaptured && step === 2 ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752553188/french-8_n42upr.mp3' :
                              process ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752553197/french-9_epdcsm.mp3' :
                                multiFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752553205/french-10_oghjkc.mp3' : 
                                  !multiFace && noFace ? 'https://res.cloudinary.com/dgeiynco8/video/upload/v1752553190/french-11_hyioh5.mp3' : '' )
                        :
                      ''
                      )
                    }
                    onPlay={() => console.log("onPlay")}
                    onEnded={() => onVoiceEnd()}
                  />
                  {/* {
                    !multiFace && 
                      <div className={frontStill || leftStill || rightStill || topStill ? 'show' : 'hide'}>
                        <p className="paraImgMsg">{i18next.t("STAY STILL")} {btnMsg} {count}</p>
                      </div>
                  } */}
                </div> : 
              isDoctor ? 
                <div className="cameraPreview assisted">
                  {
                    isLoading ?
                      <RotatingLines
                        visible={true}
                        height="96"
                        width="96"
                        color="blue"
                        strokeWidth="5"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        className={"customLoader"}
                      /> : ''
                  }
                  <div className="canvavideodiv">
                    <div className="cameraContainer">
                      <div className="videoDiv">
                        {/* {
                          !isLoading &&
                            <div className="vidprofileTxt">
                              <p>
                                {
                                  selfScanFront ? i18next.t('FRONT') : selfScanLeft ? i18next.t('LEFT PROFILE') : selfScanRight ? i18next.t('RIGHT PROFILE') : selfScanTop ? i18next.t('TOP') : ''
                                }
                              </p>
                            </div>
                        } */}
                        <Webcam
                          id="reactwebcamid"
                          ref={webcamRef}
                          onUserMediaError={handleCameraError}
                          screenshotQuality={1}
                          screenshotFormat="image/png"
                          mirrored={false}
                          videoConstraints={{
                            deviceId: selectedCamera ? { exact: selectedCamera } : undefined,
                            facingMode: selectedCamera ? undefined : "environment",
                            // width: { ideal: 1280 },
                            // height: { ideal: 720 }
                          }}
                        />
                      </div>
                      <canvas
                        ref={canvasRef}
                        className="output_canvas position-relative"
                      ></canvas>
                      <canvas
                        ref={blackCanvasRef}
                        className="output_canvas blackcanvas"
                      ></canvas>
                      {/* {
                        !isLoading && <CircularProgress variant="determinate" thickness={1.0} value={progress} className="circular_imgUpload"/>
                      } */}
                      {/* <Button onClick={() => navigate('/tutorial')}>
                        <OndemandVideoIcon/>
                      </Button>             */}
                    </div>
                  
                    <div className="scanFaceDirection">
      
                    {/* {
                      !isLoading &&
                      <div className="volumeupdiv">
                        
                        <VolumeUpIcon />
                        <p>{i18next.t("Turn up the volume")}</p>
                      </div>
                    } */}
                    {/* <div className={selfScan && selfScanLeft ? "arrowInstant right" : selfScan && selfScanRight ? "arrowInstant left" : ''}> 
                    {
                    selfScan && selfScanLeft ?
                      <img className="arrowInst white right" src="https://res.cloudinary.com/dgeiynco8/image/upload/v1751866489/fast-forward_b926_1_miyacq.gif" /> :
                      selfScan && selfScanRight ?
                        <img className="arrowInst white left" src="https://res.cloudinary.com/dgeiynco8/image/upload/v1751866499/fast-backward_7fac_1_nrjoao.gif" /> : ''
                        selfScan && selfScanTop ?
                          <img className="arrowInst" src="https://res.cloudinary.com/dgeiynco8/image/upload/v1745575693/gifs/gjycsmvrbrxobc5yf5jy.gif" /> :
                          ''
                  }
      
                    </div> */}
      
                    </div>
                  </div>
      
                  {/* <div>
                     {brightness !== null && (
                        <div className="brightnessdiv">
                          {brightness < 135 && <p className="brightnesstxt">Light Conditions Too Dark</p>}
                          {brightness > 180 && <p className="brightnesstxt">Light Conditions Too Bright</p>}
                        </div>
                      )}
      
                  </div> */}
                  
                  <Button className={( !multiFace ) ? 'captureBtn commonButton aloxacapture' : 'captureBtn disabledBtn commonButton aloxacapture'} onClick={() => captureForAssisted()} disabled={( !multiFace ) ? false : true}>
                    {i18next.t("Take a Photo")}
                  </Button>
                  {
                    multiFace &&
                    <div className="multiFaceDiv">
                      <p>{i18next.t("It seems there is more than one person in the frame. Please readjust your position.")}</p>
                    </div>
                  }
                  {
                    noFace && !selfScanTop &&
                    <div className="multiFaceDiv">
                      <p>{i18next.t("Profile not detected ")}</p>
                    </div>
                  }
                  {/* <H5AudioPlayer
                    autoPlay
                    src={
                      locale == 'en' && gender.toUpperCase() == "MALE" ? 
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645861/audio/human_audio/english/male/self/skadykywxcn3g5vkrt2l.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645374/audio/human_audio/english/male/smart/qyvp3abgusvz0xfi1vjo.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701389/audio/human_audio/english/male/self/dsivejpms6rl8npj5yuy.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645374/audio/human_audio/english/male/smart/qyvp3abgusvz0xfi1vjo.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanLeft && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701440/audio/human_audio/english/male/self/nknvrktvjq43cbuon4dl.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanLeft ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645374/audio/human_audio/english/male/smart/qyvp3abgusvz0xfi1vjo.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanRight && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701489/audio/human_audio/english/male/self/xhlnitjrwkqxazt1rs9d.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanRight ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645374/audio/human_audio/english/male/smart/qyvp3abgusvz0xfi1vjo.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645603/audio/human_audio/english/male/smart/zxfcoc2ws8wkft5rvjia.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645654/audio/human_audio/english/male/smart/ndpfbqnmgd0oalgo3uiq.mp3' : 
                          ''
                        ) : 
                      locale == 'es' && gender.toUpperCase() == "MALE"  ?
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704557/audio/human_audio/spanish/male/self/qsgs5lifnzfmj9rdescn.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749703754/audio/human_audio/spanish/male/smart/phnbvhns6f9jx5xifvnf.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704582/audio/human_audio/spanish/male/self/lebrwlxeojw1ghy13ja8.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749703754/audio/human_audio/spanish/male/smart/phnbvhns6f9jx5xifvnf.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanLeft && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704603/audio/human_audio/spanish/male/self/xnxod9mns7vpzfjh0kyt.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanLeft ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749703754/audio/human_audio/spanish/male/smart/phnbvhns6f9jx5xifvnf.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanRight && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704624/audio/human_audio/spanish/male/self/mtc2jf7xq3aqotuflpfa.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanRight ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749703754/audio/human_audio/spanish/male/smart/phnbvhns6f9jx5xifvnf.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704305/audio/human_audio/spanish/male/smart/j4hlx3z8kphfavrydvk4.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704445/audio/human_audio/spanish/male/smart/elcwypuyp7awcdmk1y1z.mp3' : 
                          ''
                        ) : 
                      locale == 'fr' && gender.toUpperCase() == "MALE"  ?
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749707192/audio/human_audio/french/male/self/xh2z8ootzghcwsbvhhlo.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709145/audio/human_audio/french/male/smart/gtfvjwbtqnv8v6f2rosu.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749707240/audio/human_audio/french/male/self/rlk6vtcwa3lcj3ssrwny.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709145/audio/human_audio/french/male/smart/gtfvjwbtqnv8v6f2rosu.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanLeft && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749707336/audio/human_audio/french/male/self/jhv8wk5eiy0d4isyrv3p.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanLeft ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709145/audio/human_audio/french/male/smart/gtfvjwbtqnv8v6f2rosu.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanRight && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749707434/audio/human_audio/french/male/self/aop7uercv6ncwdfgjgvs.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanRight ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709145/audio/human_audio/french/male/smart/gtfvjwbtqnv8v6f2rosu.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749706948/audio/human_audio/french/male/smart/io2nnkkowaaa2rlmmyuq.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749707106/audio/human_audio/french/male/smart/sprodihnhul8qydo88l3.mp3' :
                          ''
                        ) :  
                      locale == 'en' && gender.toUpperCase() == "FEMALE" ? 
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702219/audio/human_audio/english/female/self/odnx05hvcdytvs4onmb8.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701957/audio/human_audio/english/female/smart/etmvwb4xpbvweasowtw6.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702380/audio/human_audio/english/female/self/qvuxn3phm8symuug0oug.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701957/audio/human_audio/english/female/smart/etmvwb4xpbvweasowtw6.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702079/audio/human_audio/english/female/smart/fcplm8e4lgji1zzaayj4.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702110/audio/human_audio/english/female/smart/wua79jbwmb9ffuidwkc8.mp3' : 
                          ''
                        ) : 
                      locale == 'es' && gender.toUpperCase() == "FEMALE"  ?
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749705997/audio/human_audio/spanish/female/self/rxihxajgscbgskjma3vg.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749705458/audio/human_audio/spanish/female/smart/xup8o5gmobzxj9qgwngn.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749706055/audio/human_audio/spanish/female/self/odwqb1sedhupy4u4m5v7.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749705458/audio/human_audio/spanish/female/smart/xup8o5gmobzxj9qgwngn.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749705648/audio/human_audio/spanish/female/smart/op3yx5oy8n9esk0vst1l.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749705746/audio/human_audio/spanish/female/smart/xbjpnjwwiwf2p125lycj.mp3' : 
                          ''
                        ) : 
                      locale == 'fr' && gender.toUpperCase() == "FEMALE"  ?
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749710083/audio/human_audio/french/female/self/beieixes4p8pkrif9pkt.mp3  ' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709711/audio/human_audio/french/female/smart/h7evh8sc2aeozz9kvici.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749710125/audio/human_audio/french/female/self/z6hxcwz2ftknuivkqgf0.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709711/audio/human_audio/french/female/smart/h7evh8sc2aeozz9kvici.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709943/audio/human_audio/french/female/smart/zk1y3ku2995ilwsq6ujr.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749710012/audio/human_audio/french/female/smart/vavvtut8e5c8cnojuye9.mp3' : 
                          ''
                        ) :
                        ''
                    }
                    onPlay={() => console.log("onPlay")}
                    onEnded={() => onVoiceEnd()}
                  /> */}
                </div> :
                <div className="cameraPreview">
                  {
                    isLoading ?
                      <RotatingLines
                        visible={true}
                        height="96"
                        width="96"
                        color="blue"
                        strokeWidth="5"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        className={"customLoader"}
                      /> : ''
                  }
                  <div className="canvavideodiv">
                    <div className="cameraContainer">
                      <div className="videoDiv">
                        {
                          !isLoading &&
                            <div className="vidprofileTxt">
                              <p>
                                {
                                  selfScanFront ? i18next.t('FRONT') : selfScanLeft ? i18next.t('LEFT PROFILE') : selfScanRight ? i18next.t('RIGHT PROFILE') : selfScanTop ? i18next.t('TOP') : ''
                                }
                              </p>
                            </div>
                        }
                        <Webcam
                          id="reactwebcamid"
                          ref={webcamRef}
                          onUserMediaError={handleCameraError}
                          screenshotQuality={1}
                          screenshotFormat="image/png"
                          mirrored={false}
                          videoConstraints={{
                            deviceId: selectedCamera ? { exact: selectedCamera } : undefined,
                            facingMode: selectedCamera ? undefined : "environment",
                            // width: { ideal: 1280 },
                            // height: { ideal: 720 }
                          }}
                        />
                      </div>
                      <canvas
                        ref={canvasRef}
                        className="output_canvas position-relative"
                      ></canvas>
                      <canvas
                        ref={blackCanvasRef}
                        className="output_canvas blackcanvas"
                      ></canvas>
                      {
                        !isLoading && <CircularProgress variant="determinate" thickness={1.0} value={progress} className="circular_imgUpload"/>
                      }
                      <Button onClick={() => navigate('/tutorial')}>
                        <OndemandVideoIcon/>
                      </Button>
                      {isMobile && (
                        <Button 
                          className="cursor-pointer ml-10px" 
                          onClick={switchCamera}
                          style={{ marginLeft: '10px' }}
                        >
                          <CameraAltIcon className="cursor-pointer" />
                          {i18next.t("Switch Camera")}
                        </Button>
                      )}            
                    </div>
                  
                    <div className="scanFaceDirection">
      
                    {
                      !isLoading &&
                      <div className="volumeupdiv">
                        
                        <VolumeUpIcon />
                        <p>{i18next.t("Turn up the volume")}</p>
                      </div>
                    }
                    <div className={selfScan && selfScanLeft ? "arrowInstant right" : selfScan && selfScanRight ? "arrowInstant left" : ''}> 
                    {
                    selfScan && selfScanLeft ?
                      <img className="arrowInst white right" src="https://res.cloudinary.com/dgeiynco8/image/upload/v1751866489/fast-forward_b926_1_miyacq.gif" /> :
                      selfScan && selfScanRight ?
                        <img className="arrowInst white left" src="https://res.cloudinary.com/dgeiynco8/image/upload/v1751866499/fast-backward_7fac_1_nrjoao.gif" /> : ''
                        // selfScan && selfScanTop ?
                        //   <img className="arrowInst" src="https://res.cloudinary.com/dgeiynco8/image/upload/v1745575693/gifs/gjycsmvrbrxobc5yf5jy.gif" /> :
                        //   ''
                  }
      
                    </div>
      
                    </div>
                  </div>
      
                  {/* <div>
                     {brightness !== null && (
                        <div className="brightnessdiv">
                          {brightness < 135 && <p className="brightnesstxt">Light Conditions Too Dark</p>}
                          {brightness > 180 && <p className="brightnesstxt">Light Conditions Too Bright</p>}
                        </div>
                      )}
      
                  </div> */}
                  
                  <Button className={selfScanCapture ? 'captureBtn startCapturing commonButton aloxacapture' :( !multiFace && !noFace ) ? 'captureBtn commonButton aloxacapture' : 'captureBtn disabledBtn commonButton aloxacapture'} onClick={() => selfCapture()} disabled={( !multiFace && !noFace ) ? false : true}>
                    {i18next.t(selfScanCapture ? "Cancel" : "Take a Photo")}
                  </Button>
                  {
                    multiFace &&
                    <div className="multiFaceDiv">
                      <p>{i18next.t("It seems there is more than one person in the frame. Please readjust your position.")}</p>
                    </div>
                  }
                  {
                    noFace && !selfScanTop &&
                    <div className="multiFaceDiv">
                      <p>{i18next.t("Profile not detected ")}</p>
                    </div>
                  }
                  <H5AudioPlayer
                    autoPlay
                    src={
                      locale == 'en' && gender.toUpperCase() == "MALE" ? 
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645861/audio/human_audio/english/male/self/skadykywxcn3g5vkrt2l.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645374/audio/human_audio/english/male/smart/qyvp3abgusvz0xfi1vjo.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701389/audio/human_audio/english/male/self/dsivejpms6rl8npj5yuy.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645374/audio/human_audio/english/male/smart/qyvp3abgusvz0xfi1vjo.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanLeft && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701440/audio/human_audio/english/male/self/nknvrktvjq43cbuon4dl.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanLeft ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645374/audio/human_audio/english/male/smart/qyvp3abgusvz0xfi1vjo.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanRight && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701489/audio/human_audio/english/male/self/xhlnitjrwkqxazt1rs9d.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanRight ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645374/audio/human_audio/english/male/smart/qyvp3abgusvz0xfi1vjo.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645603/audio/human_audio/english/male/smart/zxfcoc2ws8wkft5rvjia.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749645654/audio/human_audio/english/male/smart/ndpfbqnmgd0oalgo3uiq.mp3' : 
                          ''
                        ) : 
                      locale == 'es' && gender.toUpperCase() == "MALE"  ?
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704557/audio/human_audio/spanish/male/self/qsgs5lifnzfmj9rdescn.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749703754/audio/human_audio/spanish/male/smart/phnbvhns6f9jx5xifvnf.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704582/audio/human_audio/spanish/male/self/lebrwlxeojw1ghy13ja8.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749703754/audio/human_audio/spanish/male/smart/phnbvhns6f9jx5xifvnf.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanLeft && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704603/audio/human_audio/spanish/male/self/xnxod9mns7vpzfjh0kyt.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanLeft ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749703754/audio/human_audio/spanish/male/smart/phnbvhns6f9jx5xifvnf.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanRight && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704624/audio/human_audio/spanish/male/self/mtc2jf7xq3aqotuflpfa.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanRight ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749703754/audio/human_audio/spanish/male/smart/phnbvhns6f9jx5xifvnf.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704305/audio/human_audio/spanish/male/smart/j4hlx3z8kphfavrydvk4.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749704445/audio/human_audio/spanish/male/smart/elcwypuyp7awcdmk1y1z.mp3' : 
                          ''
                        ) : 
                      locale == 'fr' && gender.toUpperCase() == "MALE"  ?
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749707192/audio/human_audio/french/male/self/xh2z8ootzghcwsbvhhlo.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709145/audio/human_audio/french/male/smart/gtfvjwbtqnv8v6f2rosu.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749707240/audio/human_audio/french/male/self/rlk6vtcwa3lcj3ssrwny.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709145/audio/human_audio/french/male/smart/gtfvjwbtqnv8v6f2rosu.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanLeft && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749707336/audio/human_audio/french/male/self/jhv8wk5eiy0d4isyrv3p.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanLeft ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709145/audio/human_audio/french/male/smart/gtfvjwbtqnv8v6f2rosu.mp3' :
                          !multiFace && !noFace && !selfScanCapture && selfScanRight && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749707434/audio/human_audio/french/male/self/aop7uercv6ncwdfgjgvs.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanRight ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709145/audio/human_audio/french/male/smart/gtfvjwbtqnv8v6f2rosu.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749706948/audio/human_audio/french/male/smart/io2nnkkowaaa2rlmmyuq.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749707106/audio/human_audio/french/male/smart/sprodihnhul8qydo88l3.mp3' :
                          ''
                        ) :  
                      locale == 'en' && gender.toUpperCase() == "FEMALE" ? 
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702219/audio/human_audio/english/female/self/odnx05hvcdytvs4onmb8.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701957/audio/human_audio/english/female/smart/etmvwb4xpbvweasowtw6.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702380/audio/human_audio/english/female/self/qvuxn3phm8symuug0oug.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749701957/audio/human_audio/english/female/smart/etmvwb4xpbvweasowtw6.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702079/audio/human_audio/english/female/smart/fcplm8e4lgji1zzaayj4.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749702110/audio/human_audio/english/female/smart/wua79jbwmb9ffuidwkc8.mp3' : 
                          ''
                        ) : 
                      locale == 'es' && gender.toUpperCase() == "FEMALE"  ?
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749705997/audio/human_audio/spanish/female/self/rxihxajgscbgskjma3vg.mp3' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749705458/audio/human_audio/spanish/female/smart/xup8o5gmobzxj9qgwngn.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749706055/audio/human_audio/spanish/female/self/odwqb1sedhupy4u4m5v7.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749705458/audio/human_audio/spanish/female/smart/xup8o5gmobzxj9qgwngn.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749705648/audio/human_audio/spanish/female/smart/op3yx5oy8n9esk0vst1l.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749705746/audio/human_audio/spanish/female/smart/xbjpnjwwiwf2p125lycj.mp3' : 
                          ''
                        ) : 
                      locale == 'fr' && gender.toUpperCase() == "FEMALE"  ?
                        (
                          !multiFace && !noFace && !selfScanCapture && selfScanFront && !isLoading ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749710083/audio/human_audio/french/female/self/beieixes4p8pkrif9pkt.mp3  ' :
                          !multiFace && !noFace && selfScanCapture && selfScanFront ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709711/audio/human_audio/french/female/smart/h7evh8sc2aeozz9kvici.mp3' :
                          !multiFace && !selfScanCapture && selfScanTop && !isLoading ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749710125/audio/human_audio/french/female/self/z6hxcwz2ftknuivkqgf0.mp3' :
                          !multiFace && selfScanCapture && selfScanTop ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709711/audio/human_audio/french/female/smart/h7evh8sc2aeozz9kvici.mp3' :
                          multiFace ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749709943/audio/human_audio/french/female/smart/zk1y3ku2995ilwsq6ujr.mp3' : 
                          noFace && !selfScanTop ? 
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1749710012/audio/human_audio/french/female/smart/vavvtut8e5c8cnojuye9.mp3' : 
                          ''
                        ) :
                        ''
                    }
                    onPlay={() => console.log("onPlay")}
                    onEnded={() => onVoiceEnd()}
                  />
                </div>
            }
          </div>
      }
    </div>
  );
};
export default Aloxa;